<template>
  <div>
    <vs-button
      radius
      class="mb-2 mr-2"
      color="dark"
      type="line"
      icon="qr_code_2"
      style="float: right"
      v-b-modal.Qr_Code
    />

    <b-modal id="Qr_Code" centered size="lg" title="Asset QR Codes">
      <template #modal-header-close>
        <vs-button icon="close" style="border-radius: 20px" color="red" />
      </template>

      <template>
        <vs-row>
          <vs-spacer />

          <vs-button
            color="#32C040"
            icon="content_copy"
            style="border-radius: 20px; width: 20%"
            class="mr-2"
            v-b-modal.Add_Field
          >
            Copy URLs/Info
          </vs-button>

          <vs-button
            color="#32C040"
            icon="download"
            style="border-radius: 20px; width: 20%"
            class="mr-2"
            v-b-modal.Add_Field
          >
            Download Images
          </vs-button>

          <vs-button
            color="#32C040"
            icon="print"
            style="border-radius: 20px; width: 20%"
            class="mr-2"
            v-b-modal.Add_Field
          >
            Print Options
          </vs-button>

          <vs-icon color="#fffff" icon="help" class="ml-2 mt-2" size="20px" />

          <vs-spacer />
        </vs-row>

        <br />

        <div style="text-align: center">
          <h3>AHU-01</h3>

          <br />

          <p>Having a problem with AHU-01 ?</p>

          <p>
            You can submit a work request by either scanning the QR Code or by
            visiting the following URL.
          </p>

          <div>
            <vs-row vs-w="12">
              <vs-col vs-lg="6" style="text-align: end">
                <img
                  class="mock-img"
                  src="../../assets/qr-mock/QR.png"
                  alt=""
                />
              </vs-col>

              <vs-col vs-lg="6" class="mt-4 pt-2" style="text-align: start">
                <b style="color: red">Submit a Work Request</b>

                <br />

                <br />

                <p>Asset Name : AHU-01</p>

                <p>Location Name : Bangyai</p>
              </vs-col>
            </vs-row>

            <vs-row>
              <vs-spacer />

              <vs-button
                icon="warning"
                color="warning"
                type="flat"
                size="large"
                v-b-modal.ReportProblems
                ><b>report usage problems</b></vs-button
              >
              <vs-spacer />
            </vs-row>
          </div>
          <vs-divider></vs-divider>
          <p>Scan this QR Code for a Quick shortcut to look up the asset:</p>
          <p>AHU-01</p>
          <div>
            <vs-row vs-w="12">
              <vs-col vs-lg="6" style="text-align: end">
                <img
                  class="mock-img"
                  src="../../assets/qr-mock/QR.png"
                  alt=""
                />
              </vs-col>
              <vs-col vs-lg="6" class="mt-4 pt-2" style="text-align: start">
                <b style="color: red">Look up Asset</b>
                <br />
                <br />
                <p>Asset Name : AHU-01</p>
                <p>Location Name : Bangyai</p>
              </vs-col>
            </vs-row>
            <vs-row>
              <vs-spacer />
              <vs-button
                icon="warning"
                color="warning"
                type="flat"
                size="large"
                v-b-modal.ReportProblems
                ><b>report usage problems</b></vs-button
              >
              <vs-spacer />
            </vs-row>
          </div>
        </div>
      </template>
    </b-modal>
    <b-modal
      id="ReportProblems"
      centered
      size="lg"
      title="Report usage problems"
    >
      <template #modal-header-close>
        <vs-button icon="close" style="border-radius: 20px" color="red" />
      </template>
      <template>
        <div style="text-align: center">
          <h5>Sorry you are having a problem with</h5>
          <b>AHU-01</b>
          <br />
          <b>Location</b>
        </div>
        <div>
          <b style="margin-left: 12%">Title</b>
          <input
            type="text"
            class="center"
            placeholder="Title of the Work Request"
          />
          <br />
          <b style="margin-left: 12%">Report</b>
          <input
            type="text"
            class="center"
            placeholder="Please tell us about we'll get someone working on it right away!"
            style="height: 150px"
          /><br />

          <vs-row class="positioncen">
            <vs-icon color="success" icon="person" class="mt-2 mr-2" />
            <input type="text" class="center2" placeholder="Your Name" />
          </vs-row>
          <br />
          <vs-row class="positioncen">
            <vs-icon color="success" icon="call" class="mt-2 mr-2" />
            <input type="text" class="center2" placeholder="Your Phone Name" />
          </vs-row>
          <br />
          <vs-row class="positioncen">
            <vs-icon color="success" icon="email" class="mt-2 mr-2" />
            <input type="text" class="center2" placeholder="Your Email" />
          </vs-row>
          <br />
          <vs-row class="positioncen">
            <vs-icon color="success" icon="location_on" class="mt-2 mr-2" />
            <input
              type="text"
              class="center2"
              placeholder="Please specify equipment or location. that you want to notify"
            />
          </vs-row>
          <br />
          <div class="centerdiv">
            <vs-upload
              action="https://jsonplaceholder.typicode.com/posts/"
              @on-success="successUpload"
              limit="1"
              class="mt-4"
            />
          </div>
          <div style="text-align: center">
            <p>Add Picture/Document</p>
          </div>
        </div>
      </template>
    </b-modal>
  </div>
</template>

<script>
export default {
  data() {
    return {};
  },
  mounted() {},
  methods: {},
};
</script>

<style scoped>
.center {
  box-shadow: inset 0px 0px 3px 3px #dddddd;
  background: #edecec;
  border-width: 0;
  border-radius: 10px;
  height: 35px;
  display: block;
  margin-left: auto;
  margin-right: auto;
  width: 75%;
  text-align: center;
}
.center2 {
  box-shadow: inset 0px 0px 3px 3px #dddddd;
  background: #edecec;
  border-width: 0;
  border-radius: 10px;
  height: 35px;
  /* display: block;
  margin-left: auto;
  margin-right: auto; */
  width: 75%;
  text-align: center;
}
.positioncen {
  margin-left: 8.5%;
}
.centerdiv {
  margin-left: 35%;
}
</style>
